<template>
  <RevButton
    class="rounded-full"
    variant="primary"
    v-bind="{ ...(buttonProps as any), ...$attrs }"
  >
    <span v-if="props.icon" class="flex items-center justify-center gap-6">
      <RevIllustration
        :src="props.icon"
        :width="22"
        :height="22"
        alt=""
        aria-hidden="true"
      />
      <slot />
    </span>
    <slot v-else />
  </RevButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  variant: 'primary' | 'secondary' | 'tertiary' | 'destructive'
  icon?: string
}>()

const buttonProps = computed(() => {
  const { icon: _icon, ...rest } = props
  return rest
})
</script>
